<template>
    <div class="lx-table" :class="{showScrollBar: showScrollbar}">
        <el-table
            :ref="tableName"
            :border="border"
            :data="list"
            :row-key="rowKey"
            :stripe="stripe"
            :empty-text="emptyText"
            :highlight-current-row="highlightCurrentRow"
            :header-cell-style="headerCellStyle"
            :cell-style="cellStyle"
            v-loading="loading"
            @row-click="doRow"
            @select="doSelect"
            @select-all="doSelectAll"
            @selection-change="doSelectionChange"
            >
            <!-- style="width: 100%" -->
            <el-table-column
                v-if="isSelectTable && !isCustomSelect"
                type="selection"
                label="全选"
                align="center"
                :reserve-selection="reserveSelection && !isCustomSelect"
            />
            <el-table-column prop="isChecked" width="50" label=" " v-if="isSelectTable && isCustomSelect" :key="columnKey">
                <template slot="header">
                    <!-- header中的选择框(自定义全选) -->
                    <div class="lx-header-custom lx-flex-column-center lx-fz20 ">
                         <el-checkbox
                            :checked="isCheckedAll"
                            @change="onChangeCheckedAll"
                        ></el-checkbox>
                    </div>
                </template>
                <template slot-scope="scope">
                    <!-- 列表中的选择框(自定义多选) -->
                    <div class="lx-flex-row-center" @click="handleCurrentChange(scope.row)">
                        <el-checkbox
                            :value="scope.row.isChecked"
                        ></el-checkbox>
                        <!-- :disabled="scope.row.isCheckDisabled" -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="showIndexCode" type="index" :label="$t('wzbg.wz6')" width="50" align="center"></el-table-column>
            <slot />
        </el-table>
      <div class="fake-scrollbar">
        <div
            class="fake-scrollbar-thumb"
            :style="fakeThumbStyle"
        />
      </div>
    </div>
</template>

<script>
export default {
    name: "LxTable",
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        tableName: {
            // 表格id（同一page下包括引入的组件内，唯一）
            type: String,
            default () {
                return 'formName'
            },
        },
        list: {
            // 表格数据
            type: Array,
            default() {
                return []
            },
        },
        rowKey: {
            // 行数据的Key 唯一值
            type: String,
            default: '',
        },
        stripe: {
            // 是否为斑马纹
            type: Boolean,
            default: false,
        },
        maxHeight: {
            // Table 的最大高度
            type: String,
            default: '850',
        },
        emptyText: {
            // 空数据时显示的文本内容
            type: String,
            default: '暂无数据~',
        },
        highlightCurrentRow: {
            // 是否要高亮当前行
            type: Boolean,
            default: false,
        },
        border: {
            // 是否显示纵向边框
            type: Boolean,
            default: false,
        },
        isPageable: {
            // 是否显示分页
            type: Boolean,
            default: false,
        },
        isSmallPage: {
            // 是否显示左侧内容
            type: Boolean,
            default: false,
        },
        internalPage: {
            // 当前页数
            type: Number,
            default: 1,
        },
        pageSize: {
            // 每页显示条目个数
            type: Number,
            default: 10,
        },
        total: {
            // 总条目数
            type: Number,
            default: 0,
        },
        isSelectTable: {
            // 是否显示多选
            type: Boolean,
            default: false,
        },
        isCustomSelect: {
            // 是否自定义显示多选
            type: Boolean,
            default: false,
        },
        reserveSelection: {
            type: Boolean,
            default: false,
        },
        headerCellStyle: {
            type:Object,
            default: () => {}
        },
        cellStyle: {
            type:Object,
            default: () => {}
        },
        isCheckedAll: {
            type: Boolean,
            default: false,  
        },
        showScrollbar: {
            type: Boolean,
            default: false, 
        },
        showIndexCode: {
            type: Boolean,
            default: true,
        },
    },
    data () {
        return {
            multipleSelection: [],
            currentPage: 1, // 当前页
            timeout: null,
            columnKey: 1 // 为了让列表中的全选框响应
          ,thumbHeight: 20,
          thumbTop: 0
        };
    },
    computed: {
        totalPage() {
            return Math.ceil(this.total / this.pageSize)
        },
        curPage() {
            return this.internalPage
        },
      fakeThumbStyle() {
        return {
          height: this.thumbHeight + 'px',
          transform: `translateY(${this.thumbTop}px)`
        }
      }
    },
    watch: {
        curPage(newVal) {
            this.currentPage = newVal
        },
        isCheckedAll: {
            handler() {
                this.columnKey++
            },
            deep: true
        },
      list() {
        this.$nextTick(() => {
          this.$refs[this.tableName].doLayout()
          this._scrollUpdate && this._scrollUpdate()
        })
      }
    },
  mounted() {
    this.$nextTick(() => {
      // 强制 el-table 重新计算布局
      this.$refs[this.tableName].doLayout()

      this.$nextTick(() => {
        this.bindScroll()
      })
    })
  },
    methods: {
      bindScroll() {
        const table = this.$refs[this.tableName]
        if (!table) return

        const body = table.$el.querySelector('.el-table__body-wrapper')
        if (!body) return

        const update = () => {
          const { scrollTop, scrollHeight, clientHeight } = body

          // 没有滚动内容时直接隐藏或置最小
          if (scrollHeight <= clientHeight) {
            this.thumbHeight = 0
            this.thumbTop = 0
            return
          }

          const ratio = clientHeight / scrollHeight
          const minHeight = 30

          this.thumbHeight = Math.max(clientHeight * ratio, minHeight)
          this.thumbTop =
              scrollTop * (clientHeight - this.thumbHeight) /
              (scrollHeight - clientHeight)
        }

        body.addEventListener('scroll', update)

        // ⭐ 手动执行一次
        this.$nextTick(update)

        this._scrollUpdate = update
      },
        // 点击某一行
        doRow(row, column, event) {
            this.$emit('rowClick', row, column, event)
        },
        // 当用户手动勾选数据行
        doSelect(selection, row) {
            this.$emit('select', selection, row)
        },
        // 当用户手动勾选全选
        doSelectAll(selection) {
            this.$emit('selection', selection)
        },
        // 当选择项发生变化
        doSelectionChange(selection) {
            this.$emit('selectionChange', selection)
        },
        // 自定义多选时
        handleCurrentChange(row) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.$emit('selectChange', row)
                    clearTimeout(this.timeout)
                    this.timeout = null
                }, 50)
            }
        },
        // pageSize 改变时会触发
        doSizeChange(e) {
            this.$emit('sizeChange', e)
        },
        // currentPage 改变时会触发
        doCurrentChange(e) {
            this.$emit('currentChange', e)
        },
        getRowKey(row) {
            return row.id
        },
        // 跳转第一页
        jumpFirstPage() {
            this.$refs.pagination.handleCurrentChange(1)
            // this.$emit('currentChange', 1)
        },
        // 跳转最后一页
        jumpLastPage() {
            const font = this.$refs.pagination
            const cpage = Math.ceil(font.total / font.pageSize)
            font.handleCurrentChange(cpage)
            // this.$emit('currentChange', cpage)
        },

        // 全选点击
        onChangeCheckedAll(e) {
            this.$emit('changeSelectAll', e)
        },
    },
}
</script>
<style lang="less" scoped>
.lx-table {
    height: 100%;
    ::v-deep .el-table {
        height: 100%;
        overflow: hidden !important;
    }
    ::v-deep .el-table th.gutter {
        display: table-cell!important;
    }
    ::v-deep .el-table .el-table__body-wrapper {
        height: calc(100% - 52px); // 适配滚动条区域
        overflow-y: auto !important;
    }
    ::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar {
        height: 14px;
        border-radius: 4px;
        background-color:transparent;
        width: 0;
    }
    ::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar:vertical  {
        width: 0;
    }
    ::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: rgb(165, 158, 158);
    }
    ::v-deep .el-table .is-leaf {
        height: 50px;
        line-height: 50px;
        // font-weight: bold;
        // color: var(--color-black);
        padding: 0 !important;
        // background: var(--background-3);
    }
    // ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    //     background: var(--background-3) !important;
    // }
}
.lx-table.showScrollBar {
    ::v-deep .el-table .el-table__body-wrapper::-webkit-scrollbar:vertical  {
        width: 10px;
    }
}

/* 假滚动条 */
.fake-scrollbar {
  position: absolute;
  right: 2px;
  top: 52px; /* 表头高度 */
  width: 10px;
  height: calc(100% - 52px);
  background: transparent;
}

.fake-scrollbar-thumb {
  width: 100%;
  background: rgba(0,0,0,0.3);
  border-radius: 3px;
  cursor: pointer;
}
</style>